// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/FreckleFace-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  background:
  linear-gradient(180deg, #000000 15.29%, rgba(0, 0, 0, 0) 100%),
    conic-gradient(from 34.81deg at 101.94% 101.46%, #475F02 -28.12deg, #4C0700 43.42deg, #533800 144.36deg, #0C2B4F 231.96deg, #475F02 331.88deg, #4C0700 403.42deg);


  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

html, body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  max-width: 100vw;
}

*, *::before, *::after {
  box-sizing: border-box;
}

@font-face {
  font-family: 'FreckleFace';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE;;qKAEmK;;;EAGnK,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,4CAAgD;AAClD","sourcesContent":[".App {\n  background:\n  linear-gradient(180deg, #000000 15.29%, rgba(0, 0, 0, 0) 100%),\n    conic-gradient(from 34.81deg at 101.94% 101.46%, #475F02 -28.12deg, #4C0700 43.42deg, #533800 144.36deg, #0C2B4F 231.96deg, #475F02 331.88deg, #4C0700 403.42deg);\n\n\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\nhtml, body {\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n  max-width: 100vw;\n}\n\n*, *::before, *::after {\n  box-sizing: border-box;\n}\n\n@font-face {\n  font-family: 'FreckleFace';\n  src: url('assets/fonts/FreckleFace-Regular.ttf');\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
